import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

import { useCreateOrganisationMutation } from '../../lib/graphql';
import { Spacer } from '../spacer';
import { Button, ButtonSecondary } from '../styled/button';
import { Form } from '../styled/form';
import { InputField } from '../styled/input';
import Modal, { ActionsRight, ModalActions } from '../styled/modal';

const schema = Yup.object({
  name: Yup.string().required('Verplicht'),
});

export default function CreateOrganisation({ close }) {
  const firstInput = useRef(null);
  const router = useRouter();
  const [, createOrganisation] = useCreateOrganisationMutation();

  const formik = useFormik({
    validationSchema: schema,
    initialValues: {
      name: '',
    },
    onSubmit: async (values, bag) => {
      try {
        const result = await createOrganisation({ input: values });
        if (result.data) {
          toast.success('Organisatie aangemaakt');
          close();
          router.push(`/organisations/${result.data.createOrganisation.id}`);
        } else {
          throw new Error(result.error);
        }
      } catch (err) {
        console.error(err);
        toast.error('Er ging iets fout, probeer het opnieuw');
      } finally {
        bag.setSubmitting(false);
      }
    },
  });

  /**
   * Focus the first input when the modal opens
   */
  useEffect(() => {
    if (firstInput.current) firstInput.current.focus();
  }, [firstInput]);

  return (
    <Modal
      heading="Organisatie toevoegen"
      text="Vul hier alvast de naam in van de nieuwe organisatie. Op de volgende pagina kun je de overige organisatiegegevens invullen."
      close={close}
    >
      <Form onSubmit={formik.handleSubmit}>
        <InputField
          id="name"
          name="name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.errors.name}
          placeholder="Organisatie"
          label="Organisatie"
          ref={firstInput}
        />
        <Spacer size={1.5} />
        <ModalActions>
          <ActionsRight>
            <ButtonSecondary type="button" onClick={close}>
              Annuleren
            </ButtonSecondary>
            <Spacer size={1} />
            <Button
              type="submit"
              disabled={!formik.isValid}
              loading={formik.isSubmitting}
            >
              Opslaan
            </Button>
          </ActionsRight>
        </ModalActions>
      </Form>
    </Modal>
  );
}
